import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Hidden,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { FormProvider, useForm } from "react-hook-form";
import DnerhsApi from "../../api/DnerhsApi";
import FormInput from "../../Controls/Input";
import FormSelect from "../../Controls/Select";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { Assignment as AssignmentIcon, Person as PersonIcon } from "@material-ui/icons";
import { Link as RouterLink, useParams } from "react-router-dom";
import SubmitConvenioDialog from "../../SubmitConvenioDialog/SubmitConvenioDialog";
import FormDialog from "./FormDialog/FormDialog";
import Alert from "../../components/Alert";
import AlertMUI from '@material-ui/lab/Alert';
import Roles from "../../constants/Roles";
import useAuth from "../../hooks/Auth";
import history from "../../utils/History";
import { getSedeSeleccionada } from "services/UsuarioService"
import { trackPromise } from 'react-promise-tracker';
import ConfirmDialog from "dialogs/ConfirmDialogSolicitudConvenio";
import ConfirmDialogAprobar from "./FormDialog/ConfirmDialogAprobar";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: theme.spacing(10),
    paddingRight: theme.spacing(10),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  field: {
    margin: theme.spacing(),
  },
  submit: {
    padding: theme.spacing(2),
  },
  alert: {
    color: "#ff0000",
  },
  cell : {
    fontSize: 18 
  }
}));

const categoriasOptions = [
  {
    id: "Grado",
    label: "Grado",
  },
  {
    id: "Postgrado",
    label: "Postgrado",
  },
  {
    id: "Pregrado",
    label: "Pregrado",
  },
];



const firmaConvenio = [
  {
    id: 1,
    descripcion:
      "Descarga del convenio para firma manuscrita de la máxima autoridad",
    estado: "",
    path: "/descargarConvenio",
    rolesRequired : [Roles.ROLE_DNERHS, Roles.ROLE_USER]
  },
  {
    id: 2,
    descripcion:
      "Registrar fecha de vigencia del convenio posterior a la firma",
    estado: "",
    path: "/registroVigencia",
    rolesRequired : [Roles.ROLE_DNERHS]
  },
];

const practicas = [
  /* {
    id: 1,
    descripcion: "Estudiantes",
    estado: "",
    path: "/alumnos",
  }, */
  {
    id : 2,
    descripcion : "Solicitudes y asignaciones de plazas",
    estado : "Sin carga",
    path : "/convenios/asignacionPlazas/solicitudes"
  },
  {
    id: 3,
    descripcion: "Datos de los tutores",
    estado: "Sin carga",
    path: "/convenios/tutores",
  },
  {
    id: 3,
    descripcion: "Datos de los estudiantes",
    estado: "Sin carga",
    path: "/convenios/estudiantes",
  },
  {
    id: 3,
    descripcion: "Datos estadisticos de estudiantes",
    estado: "Sin carga",
    path: "/convenios/profesionalesFormados",
  },
  {
    id: 4,
    descripcion: "Datos de los cronogramas de prácticas",
    estado: "Sin carga",
    path: "/convenios/cronogramasPracticas",
  },
  {
    id: 6,
    descripcion: "Datos de las asistencias de prácticas",
    estado: "Sin carga",
    path: "/convenios/confirmacionesPracticas",
  },
  /*{
    id: 3,
    descripcion: "Campos de Prácticas",
    estado: "",
    path: "/camposPractica",
  },
  {
    id: 4,
    descripcion: "Prácticas",
    estado: "",
    path: "/practicasEstudiantes",
  }, */
];

const Form = () => {
  const classes = useStyles();
  const [saved, setSaved] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [sent, setSent] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isPrimerConvenio, setIsPrimerConvenio] = useState(false);
  const [institucionFormadoraId, setInstitucionFormadoraId] = useState();
  const [institucionFormadora, setInstitucionFormadora] = useState();
  const [institucionFormadoraResponseData, setInstitucionFormadoraResponseData] = useState({});
  const [observacion, setObservacion] = useState("");
  const [usuarioRevisor, setUsuarioRevisor] = useState();
  const [fechaRevision, setFechaRevision] = useState();
  const [sede, setSede] = useState();
  const [estadoConvenio, setEstadoConvenio] = useState("");
  const [procesado, setProcesado] = useState(false);
  const [openRechazoDialog, setOpenRechazoDialog] = useState(false);
  const params = useParams();
  const isAddMode = !params.id;
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogAprobar, setOpenDialogAprobar] = useState(false);
  const { hasRole, hasAnyRole } = useAuth();
  const methods = useForm({});
  const { handleSubmit, errors, reset, setValue, getValues, formState } = methods;
  const [isHabilitarRevision, setIsHabilitarRevision] = useState(true);
  const [b1LeyCreacion, setB1LeyCreacion] = useState(true);
  const [b2CarreraConvenio, setB2CarreraConvenio] = useState(true);
  const [b3Rector, setB3Rector] = useState(true);
  const [b4Decano, setB4Decano] = useState(true);
  const [b5SolicitudSuscripcion, setB5SolicitudSuscripcion] = useState(true);
  const [b6RespaldoAcademico, setB6RespaldoAcademico] = useState(true);
  const [periodosConvenio, setPeriodosConvenio] = useState([]);
  const [openSolicitudRenovacion, setOpenSolicitudRenovacion] = useState(false);
  const [openGestionarRenovacion, setOpenGestionarRenovacion] = useState(false);
  const [openRechazoRenovacion, setOpenRechazoRenovacion] = useState(false);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [motivoRechazoRenovacion, setMotivoRechazoRenovacion] = useState("");
  const [renovacionForm, setRenovacionForm] = useState({
    observacion: "",
  });
  const [gestionAcademicaForm, setGestionAcademicaForm] = useState({
    numeroPeriodo: "",
    fechaInicioGestion: "",
    fechaFinGestion: "",
    observacion: "",
  });
  const [aprobarRenovacionForm, setAprobarRenovacionForm] = useState({
    numeroPeriodo: "",
    fechaFirma: "",
    fechaInicioVigencia: "",
    fechaFinVigencia: "",
    numeroResolucion: "",
    observacion: "",
  });

  // Estadísticas de rectificación
  const [statsRectificacion, setStatsRectificacion] = useState({
    practicasRectificadas: 0,
    alumnosRectificados: 0
  });
  const cargaDatosDocumentacion = [
    {
      id: 1,
      descripcion: "Datos de la institución formadora",
      estado: "Datos cargados",
      path: "/instituciones/crear",
      botoncargado: b1LeyCreacion
    },
    {
      id: 2,
      descripcion: "Carreras o programas incluídos en el convenio",
      estado: "3 Carreras/Programas cargadas",
      path: "/convenios/carreras",
      botoncargado: b2CarreraConvenio
    },
    {
      id: 3,
      descripcion: "Datos de las autoridades de la institución formadora",
      estado: "Sin carga",
      path: "/autoridades",
      botoncargado: (b3Rector && b4Decano)
    },
    {
      id: 4,
      descripcion: "Solicitud de suscripción de convenio",
      estado: "Sin carga",
      path: "/solicitudSuscripcion",
      botoncargado: b5SolicitudSuscripcion
    },
    {
      id: 5,
      descripcion: "Documentos de respaldo académico",
      estado: "Datos cargados",
      path: "/docsRespaldo",
     
      botoncargado: b6RespaldoAcademico
    }
  ];
  useEffect(() => {
    const load = () => {
      try {
        if (!isAddMode) {
          setValuesForEdit();
        } else {
          getServerData();
        }
      } catch (error) {
        console.log(error);
      }
    };

    load();
  }, []);

  const setValuesForEdit = async () => {
    try {
      //const datosInstitucion = getSedeSeleccionada();
      let urlconvenio = `/convenios/${params.id}`; 
      const {data : responseConvenio} = await DnerhsApi(urlconvenio);
      //verificar si es el primer convenio
      let urlPrimerConvenio = `/convenios/institucionFormadora/${responseConvenio?.institucionFormadora?.id}/primer-convenio`; 
      const {data : responsePrimerConvenio} = await DnerhsApi(urlPrimerConvenio);
      if(responsePrimerConvenio?.convenioId.toString()===params.id){
      setIsPrimerConvenio(true);
      }else{
        setIsPrimerConvenio(false);
      }
      //verificar habilitacion boton solicitud revision && setIsHabiliarRevision
      let urlBotonRevision = `/convenios/${params.id}/validar-solicitar-revision`;   
      const {data : habilitarBotonRevision} = await DnerhsApi(urlBotonRevision);

      console.log('habilitarBotonRevision', habilitarBotonRevision);

      setIsHabilitarRevision(habilitarBotonRevision.validacion);
      setB1LeyCreacion(habilitarBotonRevision?.b1LeyCreacion);
      setB2CarreraConvenio(habilitarBotonRevision?.b2CarreraConvenio);
      setB3Rector(habilitarBotonRevision?.b3Rector);
      setB4Decano(habilitarBotonRevision?.b4Decano);
      setB5SolicitudSuscripcion(habilitarBotonRevision?.b5SolicitudSuscripcion);
      setB6RespaldoAcademico(habilitarBotonRevision?.b6RespaldoAcademico);
      let url = `/convenios/${params.id}`;
      const {data : institucionFormadoraResponseData} = await DnerhsApi(url);

      console.log("setValues", institucionFormadoraResponseData);

      const values = {
        categoria: institucionFormadoraResponseData.categoria,
        estado: institucionFormadoraResponseData.estado
      };
      const fields = [
        "categoria",
        "estado",
        /* "fechaInicio",
        "fechaFin", */
        "sede",
        "institucion",
      ];

      fields.forEach((x) => setValue(x, values[x]));
      setInstitucionFormadoraResponseData(institucionFormadoraResponseData);
      setInstitucionFormadora(institucionFormadoraResponseData.institucionFormadora.institucion);
      setSede(institucionFormadoraResponseData.institucionFormadora.sede);
      setEstadoConvenio(institucionFormadoraResponseData.estado);
      setObservacion(institucionFormadoraResponseData.observacion);
      setUsuarioRevisor(institucionFormadoraResponseData.usuarioRevisor);
      setFechaRevision(institucionFormadoraResponseData.fechaRevision);

      // Cargar estadísticas de rectificación
      loadRectificacionStats();
      loadPeriodosConvenio();
    } catch (error) {
      console.log(error);
    }
  };

  const loadRectificacionStats = async () => {
    try {
      const url = `/practicas-convenio/convenio/${params.id}`;
      console.log('🔍 Cargando estadísticas de rectificación para convenio:', params.id);
      const { data } = await DnerhsApi.get(url);
      console.log('📊 Datos de prácticas recibidos:', data);
      console.log('📊 Total registros:', data.length);

      // Agrupar por cronogramaId (prácticas únicas)
      const practicasRectificadas = new Set();
      const alumnosRectificados = new Set();

      data.forEach(row => {
        if (row.rectificado === true) {
          if (row.cronogramaId) {
            practicasRectificadas.add(row.cronogramaId);
          }
          if (row.cedulaIdentidad) {
            alumnosRectificados.add(row.cedulaIdentidad);
          }
        }
      });

      const stats = {
        practicasRectificadas: practicasRectificadas.size,
        alumnosRectificados: alumnosRectificados.size
      };

      console.log('✅ Estadísticas de rectificación:', stats);
      setStatsRectificacion(stats);
    } catch (error) {
      console.log('❌ Error al cargar estadísticas de rectificación:', error);
      // No mostrar error al usuario, solo registrar en consola
    }
  };

  const loadPeriodosConvenio = async () => {
    if (!params.id) return;
    try {
      const { data } = await DnerhsApi.get(`/convenios/${params.id}/periodos`);
      setPeriodosConvenio(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log("Error al cargar periodos del convenio:", error);
      setPeriodosConvenio([]);
    }
  };

  const formatDate = (value) => value ? new Date(value).toLocaleDateString("es-PY") : "Sin fecha";
  const formatDateRange = (desde, hasta, fallback = "Pendiente DNERHS") => {
    if (!desde && !hasta) return fallback;
    return `${formatDate(desde)} - ${formatDate(hasta)}`;
  };

  const renovaciones = periodosConvenio.filter((periodo) => periodo.tipoPeriodo === "RENOVACION");
  const renovacionPendiente = renovaciones.find((periodo) =>
    periodo.estado === "SOLICITADA" || periodo.estado === "EN_GESTION_ACADEMICA"
  );
  const siguienteNumeroRenovacion = Math.min(
    3,
    Math.max(
      0,
      ...renovaciones
        .filter((periodo) => periodo.numeroPeriodo)
        .map((periodo) => Number(periodo.numeroPeriodo))
    ) + 1
  );

  const getServerData = async () => {
    try {
       //verificar si es el primer convenio
      //let urlPrimerConvenio = `/institucionFormadora/${params.id}/primer-convenio`; 
      //const {data : responsePrimerConvenio} = await DnerhsApi(urlPrimerConvenio);

      const datosInstitucion = getSedeSeleccionada();

      if (isAddMode) {
        const values = {
          institucion: datosInstitucion.formadora.institucion,
          sede: datosInstitucion.sede,
        };
        const fields = ["institucion", "sede"];
        fields.forEach((x) => setValue(x, values[x]));
        setInstitucionFormadoraId(datosInstitucion.formadora.id);
        setInstitucionFormadora(datosInstitucion.formadora.institucion);
        setSede(datosInstitucion.formadora.sede);
      }
    } catch (err) {
      console.log(err);
      Alert.show({
        message : "Error al obtener los datos",
        type : "error"
      })
    
    }
  };

  const onSubmit = async (data) => {
    
    let url = "/convenios";

    const payload = {
      categoria: data.categoria,
    };

    try {
      if (isAddMode) {
        payload.institucionFormadora = {
          id: institucionFormadoraId,
        };

        const response = await trackPromise(DnerhsApi.post(url, {
          ...payload,
        }));
        setSent(true)
        Alert.show({
          message: "Datos Guardados exitosamente",
          type: "success",
        });
        //reset();
        setSaved(true);
        history.replace(`/convenios/editar/${response.data.id}`);
      } else {
        const response = await trackPromise(DnerhsApi.put(url, {
          ...institucionFormadoraResponseData,
          ...payload,
        }));
        setSent(true)
        Alert.show({
          message: "Datos actualizados exitosamente",
          type: "success",
        });
        //reset();
        setSaved(true);
        setIsEditMode(false);
        //window.location.href = `/convenios/editar/${response.data.id}`;
      }
    } catch (error) {
      console.log(error);
      Alert.showServerError(error);
    }
  };
  const handleOpenDialogAprobar = () => {
    setOpenDialogAprobar(true);
  };
  const handleCloseDialogAprobar = () => {
    setOpenDialogAprobar(false);
    setSent(true);
  };
  const onAcceptDialogAprobar = (vigencia = 0) => {
    console.log(vigencia)
    setOpenDialogAprobar(false);
    aprobarRechazar("Convenio pendiente de firma","",vigencia);
  };
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSent(true);
  };

  const enviarSolicitud = async () => {
    setOpenDialog(false);
    try {
      let url = `/convenios/${params.id}/revision`; 
      const response = await trackPromise(DnerhsApi.post(url));
      setSent(true);

        Alert.show({
          message : "Solicitud de convenio enviado exitosamente.",
          type : "success"
        })
        window.location.href = `/convenios/editar/${params.id}`;
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const solicitarRenovacion = async () => {
    try {
      await trackPromise(DnerhsApi.post(
        `/convenios/${params.id}/periodos/renovacion/solicitar`,
        null,
        { params: renovacionForm }
      ));
      Alert.show({ message: "Solicitud de renovacion enviada correctamente", type: "success" });
      setOpenSolicitudRenovacion(false);
      setRenovacionForm({ observacion: "" });
      loadPeriodosConvenio();
    } catch (error) {
      console.log(error);
      Alert.showServerError(error);
    }
  };

  const abrirGestionarRenovacion = (periodo) => {
    setPeriodoSeleccionado(periodo);
    setGestionAcademicaForm({
      numeroPeriodo: periodo.numeroPeriodo || siguienteNumeroRenovacion,
      fechaInicioGestion: periodo.fechaInicioGestion ? moment(periodo.fechaInicioGestion).format("YYYY-MM-DD") : "",
      fechaFinGestion: periodo.fechaFinGestion ? moment(periodo.fechaFinGestion).format("YYYY-MM-DD") : "",
      observacion: periodo.observacion || "",
    });
    setAprobarRenovacionForm({
      numeroPeriodo: periodo.numeroPeriodo || siguienteNumeroRenovacion,
      fechaFirma: periodo.fechaFirma ? moment(periodo.fechaFirma).format("YYYY-MM-DD") : "",
      fechaInicioVigencia: periodo.fechaInicioVigencia ? moment(periodo.fechaInicioVigencia).format("YYYY-MM-DD") : "",
      fechaFinVigencia: periodo.fechaFinVigencia ? moment(periodo.fechaFinVigencia).format("YYYY-MM-DD") : "",
      numeroResolucion: periodo.numeroResolucion || "",
      observacion: periodo.observacion || "",
    });
    setOpenGestionarRenovacion(true);
  };

  const autorizarGestionAcademica = async () => {
    if (!periodoSeleccionado) return;
    if (!gestionAcademicaForm.fechaInicioGestion || !gestionAcademicaForm.fechaFinGestion) {
      Alert.show({ message: "DNERHS debe cargar inicio y fin de gestion academica", type: "error" });
      return;
    }

    try {
      await trackPromise(DnerhsApi.put(
        `/convenios/${params.id}/periodos/${periodoSeleccionado.id}/renovacion/autorizar-gestion`,
        null,
        {
          params: {
            numeroPeriodo: gestionAcademicaForm.numeroPeriodo,
            fechaInicioGestion: gestionAcademicaForm.fechaInicioGestion,
            fechaFinGestion: gestionAcademicaForm.fechaFinGestion,
            observacion: gestionAcademicaForm.observacion || "Gestion academica autorizada por DNERHS",
          },
        }
      ));
      Alert.show({ message: "Gestion academica autorizada", type: "success" });
      setPeriodoSeleccionado({
        ...periodoSeleccionado,
        estado: "EN_GESTION_ACADEMICA",
        numeroPeriodo: gestionAcademicaForm.numeroPeriodo,
        fechaInicioGestion: gestionAcademicaForm.fechaInicioGestion,
        fechaFinGestion: gestionAcademicaForm.fechaFinGestion,
        observacion: gestionAcademicaForm.observacion || periodoSeleccionado.observacion,
      });
      setAprobarRenovacionForm({
        ...aprobarRenovacionForm,
        numeroPeriodo: gestionAcademicaForm.numeroPeriodo,
        observacion: gestionAcademicaForm.observacion || aprobarRenovacionForm.observacion,
      });
      loadPeriodosConvenio();
    } catch (error) {
      console.log(error);
      Alert.showServerError(error);
    }
  };

  const abrirRechazoRenovacion = () => {
    setMotivoRechazoRenovacion(
      aprobarRenovacionForm.observacion ||
      gestionAcademicaForm.observacion ||
      periodoSeleccionado?.observacion ||
      ""
    );
    setOpenRechazoRenovacion(true);
  };

  const rechazarRenovacion = async () => {
    if (!periodoSeleccionado) return;

    const motivo = motivoRechazoRenovacion.trim();
    if (!motivo) {
      Alert.show({ message: "Debe cargar el motivo del rechazo", type: "error" });
      return;
    }

    try {
      await trackPromise(DnerhsApi.put(
        `/convenios/${params.id}/periodos/${periodoSeleccionado.id}/renovacion/rechazar`,
        null,
        { params: { observacion: motivo } }
      ));
      Alert.show({ message: "Solicitud de renovacion rechazada", type: "success" });
      setOpenRechazoRenovacion(false);
      setOpenGestionarRenovacion(false);
      setPeriodoSeleccionado(null);
      setMotivoRechazoRenovacion("");
      await loadPeriodosConvenio();
    } catch (error) {
      console.log(error);
      Alert.showServerError(error);
    }
  };

  const aprobarRenovacion = async () => {
    if (!periodoSeleccionado) return;
    if (!aprobarRenovacionForm.fechaInicioVigencia || !aprobarRenovacionForm.fechaFinVigencia) {
      Alert.show({ message: "Debe cargar inicio y fin de vigencia", type: "error" });
      return;
    }

    try {
      await trackPromise(DnerhsApi.put(
        `/convenios/${params.id}/periodos/${periodoSeleccionado.id}/renovacion/aprobar`,
        null,
        {
          params: {
            numeroPeriodo: aprobarRenovacionForm.numeroPeriodo,
            fechaFirma: aprobarRenovacionForm.fechaFirma || null,
            fechaInicioVigencia: aprobarRenovacionForm.fechaInicioVigencia,
            fechaFinVigencia: aprobarRenovacionForm.fechaFinVigencia,
            fechaInicioGestion: periodoSeleccionado.fechaInicioGestion ? moment(periodoSeleccionado.fechaInicioGestion).format("YYYY-MM-DD") : null,
            fechaFinGestion: periodoSeleccionado.fechaFinGestion ? moment(periodoSeleccionado.fechaFinGestion).format("YYYY-MM-DD") : null,
            numeroResolucion: aprobarRenovacionForm.numeroResolucion || null,
            cartaCompromiso: true,
            observacion: aprobarRenovacionForm.observacion || null,
          },
        }
      ));
      Alert.show({ message: "Renovacion aprobada correctamente", type: "success" });
      setOpenGestionarRenovacion(false);
      setPeriodoSeleccionado(null);
      loadPeriodosConvenio();
      setValuesForEdit();
    } catch (error) {
      console.log(error);
      Alert.showServerError(error);
    }
  };

  const aprobarRechazar = async (estado, motivo, vigencia) => {
    console.log('estado', estado);
    console.log('motivo', motivo);
    console.log('vigencia', vigencia);
    
    if (vigencia == undefined){
      vigencia = 0
    }

    console.log('vigencia', vigencia);

    try {
      let url = `/convenios/${params.id}/aprobacion?estado=${estado}&id=${params.id}&observacion=${motivo}&vigencia=${vigencia}`;
      const response = await trackPromise(DnerhsApi.post(url));
      setSent(true);
        Alert.show({
          message : `${estado}`,
          type : "success"
        })
        setProcesado(true);
        window.location.href = `/convenios/editar/${params.id}`;
    } catch (error) {
      console.log(error);
      if (error.response) {
        Alert.showServerError(error);
      }
    }
  };

  const handleOpenRechazoDialog = () => {
    setOpenRechazoDialog(true);
  };

  const handleCloseRechazoDialog = (value) => {
    setOpenRechazoDialog(false);
  };


  const onAcceptRechazoDialog = (value) => {
    setOpenRechazoDialog(false);
    aprobarRechazar("Convenio con correcciones solicitadas por DNERHS", value);
  };
  /* <SubmitConvenioDialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      /> */

  return (
    <div>
      <div>
        <Paper>
          <Grid item xs={12}>
            <Grid item xs={12} className={classes.field}>
              <Typography
                color="primary"
                className={classes.title}
                variant="h4"
              >
                {institucionFormadora}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.field}>
              <Typography
                color="primary"
                className={classes.title}
                variant="h5"
              >
                Sede {sede}
              </Typography>
            </Grid>
          </Grid>
          <FormProvider {...methods}>
            <form>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={6} className={classes.form}>
                  <Hidden xlDown>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput
                        name="institucion"
                        label="Institución"
                        disabled={true}
                      />
                    </Grid>
                    <Grid item xs={12} className={classes.field}>
                      <FormInput name="sede" label="Sede" disabled={true} />
                    </Grid>
                  </Hidden>
                  <Grid item xs={12} className={classes.field}>
                    <FormSelect
                      name="categoria"
                      label="Categoría"
                      options={categoriasOptions}
                      disabled={!isAddMode && !isEditMode}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={6} className={classes.form}>
                  {!isAddMode && (
                    <Grid item xs={12} className={classes.field}>
                      <FormInput name="estado" label="Estado" disabled={true} />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </form>
          </FormProvider>
          {!hasRole(Roles.ROLE_DNERHS) && (
            //<Hidden xlDown>
            <Grid  
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              
            >
              
              {isPrimerConvenio===true? (
               <Box marginLeft={2}>
                <Typography 
                  variant="h5"
                  color="primary"
                  align="left"
                  className={classes.title}
                >
                  Primer Convenio
                </Typography>
              </Box>
              ):(
                <Box marginLeft={2}>
                <Typography 
                  variant="h5"
                  color="primary"
                  align="left"
                  className={classes.title}
                >
                 </Typography>
              </Box>
              )
              }
              
              {isAddMode || isEditMode ? (
                <Grid item className={classes.submit}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Guardar
                  </Button>
                </Grid>
              ) : (
                <Grid item className={classes.submit}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setIsEditMode(true)}
                  >
                    Editar
                  </Button>
                </Grid>
              )}
            </Grid>
            //</Hidden>
          )}
        </Paper>
      </div>

      <Box paddingTop={2} paddingBottom={2}>
        <AlertMUI severity="warning">             
          Todas las documentaciones y datos proveídos tienen carácter de
          Declaración Jurada
        </AlertMUI>
      </Box>

      {estadoConvenio ===
        "Convenio con correcciones solicitadas por DNERHS" && (
        <Card className={classes.root} variant="outlined">
          <CardContent>
            <Typography variant="h5" color="secondary">
               Correcciones solicitadas
            </Typography>
            <Typography className={classes.pos} color="primary">
              {observacion}
            </Typography>
            <Typography variant="body2" component="p">
              Rechazado por: {usuarioRevisor}
            </Typography>
            <Typography variant="body2" component="p">
              Fecha: {fechaRevision}
            </Typography>
          </CardContent>
        </Card>
      )}

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper>
            <Box p={1}>
              <Typography
                variant="h5"
                color="primary"
                align="left"
                className={classes.title}
              >
                Solicitud de convenio
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Secciones</TableCell>
                    <TableCell align="right" />
                    {/* <TableCell align="left">Estado</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cargaDatosDocumentacion.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="left" className={classes.cell}>
                        {row.descripcion}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          variant="contained"
                          color={row.botoncargado?"primary":"primary-outline"}
                          size="small"
                          className={classes.button}
                          component={RouterLink}
                          to={`${row.path}/${params.id}`}
                          disabled={isAddMode}
                          startIcon={
                            (isAddMode || hasRole(Roles.ROLE_DNERHS)) ? <VisibilityIcon /> : <EditIcon />
                          }
                        >
                          {hasRole(Roles.ROLE_DNERHS)?"Revisar":"Editar"}
                        </Button>
                      </TableCell>
                      {/* <TableCell align="left">{row.estado}</TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {!hasRole(Roles.ROLE_DNERHS) ? (
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Grid item className={classes.submit}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleOpenDialog()}
                      disabled={ !(
                        (estadoConvenio == "Convenio en proceso de creación por el responsable" ||
                        estadoConvenio == "Convenio con correcciones solicitadas por DNERHS") && isHabilitarRevision) 
                      }
                    > 
                      Solicitar revisión
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                >
                  <Grid item className={classes.field}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleOpenRechazoDialog()}
                      disabled={
                        estadoConvenio !==
                        "Convenio pendiente de revisión por DNERHS"
                      }
                    >
                      Rechazar
                    </Button>
                  </Grid>
                  <Grid item className={classes.field}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        handleOpenDialogAprobar()                       
                      }
                      disabled={
                        estadoConvenio !==
                        "Convenio pendiente de revisión por DNERHS"
                      }
                    >
                      Aprobar
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Box>
            <ConfirmDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onAccept={enviarSolicitud}
            aria-labelledby="form-dialog-title"
          />
          <ConfirmDialogAprobar
            open={openDialogAprobar}
            onClose={handleCloseDialogAprobar}
            onAccept={onAcceptDialogAprobar}
            aria-labelledby="form-dialog-title"
          />
          </Paper>
        </Grid>
      </Grid>
      {!isAddMode && estadoConvenio === "Convenio firmado" && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper>
              <Box p={1}>
                <Typography
                  variant="h5"
                  color="primary"
                  align="left"
                  className={classes.title}
                >
                  Renovacion de convenio
                </Typography>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2">
                      <strong>Vigencia actual:</strong> {formatDate(institucionFormadoraResponseData.fechaInicioVigencia)} - {formatDate(institucionFormadoraResponseData.fechaFinVigencia)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography variant="body2">
                      <strong>Renovacion:</strong> {institucionFormadoraResponseData.tipoRenovacion || "Sin renovacion vigente"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {!hasRole(Roles.ROLE_DNERHS) && (
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={Boolean(renovacionPendiente) || siguienteNumeroRenovacion > 3}
                        onClick={() => setOpenSolicitudRenovacion(true)}
                      >
                        Solicitar renovacion
                      </Button>
                    )}
                  </Grid>
                </Grid>

                {renovaciones.length === 0 ? (
                  <Box marginTop={2}>
                    <Typography variant="body2" color="textSecondary">
                      No hay renovaciones registradas para este convenio.
                    </Typography>
                  </Box>
                ) : (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Nro.</TableCell>
                        <TableCell>Estado</TableCell>
                        <TableCell>Gestion academica</TableCell>
                        <TableCell>Vigencia renovada</TableCell>
                        <TableCell>Observacion</TableCell>
                        {hasRole(Roles.ROLE_DNERHS) && <TableCell align="right">Acciones</TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {renovaciones.map((periodo) => (
                        <TableRow key={periodo.id}>
                          <TableCell>{periodo.numeroPeriodo || "Pendiente"}</TableCell>
                          <TableCell>
                            <Chip
                              size="small"
                              label={periodo.estado}
                              color={periodo.estado === "APROBADA" ? "primary" : "default"}
                            />
                          </TableCell>
                          <TableCell>{formatDateRange(periodo.fechaInicioGestion, periodo.fechaFinGestion)}</TableCell>
                          <TableCell>{formatDateRange(periodo.fechaInicioVigencia, periodo.fechaFinVigencia, "Pendiente de firma")}</TableCell>
                          <TableCell>{periodo.observacion || ""}</TableCell>
                          {hasRole(Roles.ROLE_DNERHS) && (
                            <TableCell align="right">
                              {(periodo.estado === "SOLICITADA" || periodo.estado === "EN_GESTION_ACADEMICA") && (
                                <Button
                                  size="small"
                                  color="primary"
                                  variant="contained"
                                  onClick={() => abrirGestionarRenovacion(periodo)}
                                >
                                  Gestionar renovacion
                                </Button>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper>
            <Box p={1}>
              <Typography
                variant="h5"
                color="primary"
                align="left"
                className={classes.title}
              >
                Firma manuscrita del convenio
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Secciones</TableCell>
                    <TableCell align="right" />
                    {/* <TableCell align="left">Estado</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {firmaConvenio.map((row, index) => (
                    hasAnyRole(row.rolesRequired) && 
                    <TableRow key={index}>
                      <TableCell align="left" className={classes.cell}>
                        {row.descripcion}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.button}
                          component={RouterLink}
                          to={`${row.path}/${params.id}`}
                          disabled={
                            isAddMode ||
                           estadoConvenio !== "Convenio pendiente de firma"
                          }
                          startIcon={
                            (isAddMode || hasRole(Roles.ROLE_DNERHS)) ? <VisibilityIcon /> : <EditIcon />
                          }
                        >
                           {hasRole(Roles.ROLE_DNERHS)?"Revisar":"Editar"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper>
            <Box p={1}>
              <Typography
                variant="h5"
                color="primary"
                align="left"
                className={classes.title}
              >
                Carga de datos para certificados de práctica
              </Typography>
              <Table size="small" disabled>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Secciones</TableCell>
                    <TableCell align="right" />
                    {/* <TableCell align="left">Estado</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {practicas.map((row, index) => {
                    // Debug: Log para verificar
                    if (row.id === 4) {
                      console.log('🔍 Fila de cronogramas:', row);
                      console.log('📊 Stats rectificación:', statsRectificacion);
                      console.log('✅ Mostrar badges?', row.id === 4 && statsRectificacion.practicasRectificadas > 0);
                    }

                    return (
                    <TableRow key={index}>
                      <TableCell align="left" className={classes.cell}>
                        <Box display="flex" alignItems="center">
                          <span>{row.descripcion}</span>
                          {row.id === 4 && statsRectificacion.practicasRectificadas > 0 && (
                            <Box display="flex" style={{ marginLeft: '16px', gap: '8px' }}>
                              <Chip
                                icon={<AssignmentIcon style={{ color: '#e65100' }} />}
                                label={`${statsRectificacion.practicasRectificadas} Práctica${statsRectificacion.practicasRectificadas !== 1 ? 's' : ''} Rectificada${statsRectificacion.practicasRectificadas !== 1 ? 's' : ''}`}
                                size="small"
                                style={{
                                  backgroundColor: '#fff3e0',
                                  color: '#e65100',
                                  fontWeight: 600,
                                  marginRight: '8px'
                                }}
                              />
                              <Chip
                                icon={<PersonIcon style={{ color: '#1976d2' }} />}
                                label={`${statsRectificacion.alumnosRectificados} Alumno${statsRectificacion.alumnosRectificados !== 1 ? 's' : ''} Rectificado${statsRectificacion.alumnosRectificados !== 1 ? 's' : ''}`}
                                size="small"
                                style={{
                                  backgroundColor: '#e3f2fd',
                                  color: '#1976d2',
                                  fontWeight: 600
                                }}
                              />
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className={classes.button}
                          component={RouterLink}
                          to={`${row.path}/${params.id}`}
                          disabled={
                            isAddMode || estadoConvenio !== "Convenio firmado"
                          }
                          startIcon={
                            (isAddMode || hasRole(Roles.ROLE_DNERHS)) ? <VisibilityIcon /> : <EditIcon />
                          }
                        >
                           {hasRole(Roles.ROLE_DNERHS)?"Revisar":"Editar"}
                        </Button>
                      </TableCell>
                      {/* <TableCell align="left">{row.estado}</TableCell> */}
                    </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        spacing={2}
        alignItems="center"
      >
        <Grid item>
          <Button
            variant="contained"
            color="default"
            //onClick={() => history.goBack()}
            onClick={() => history.push({
              pathname: `/convenios`,
            })}
          >
            Atrás
          </Button>
        </Grid>
      </Grid>
     
      <FormDialog
        open={openRechazoDialog}
        onClose={handleCloseRechazoDialog}
        onAccept={onAcceptRechazoDialog}
        aria-labelledby="form-dialog-title"
      />
      <Dialog open={openSolicitudRenovacion} onClose={() => setOpenSolicitudRenovacion(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Solicitar renovacion de convenio</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Motivo / observacion"
                fullWidth
                multiline
                rows={3}
                value={renovacionForm.observacion}
                onChange={(event) => setRenovacionForm({ ...renovacionForm, observacion: event.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                Las fechas de gestion academica seran definidas por DNERHS al autorizar el pedido.
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSolicitudRenovacion(false)}>
            Cancelar
          </Button>
          <Button color="primary" variant="contained" onClick={solicitarRenovacion}>
            Enviar solicitud
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openGestionarRenovacion} onClose={() => setOpenGestionarRenovacion(false)} maxWidth="md" fullWidth>
        <DialogTitle>Gestionar renovacion</DialogTitle>
        <DialogContent>
          <Box marginBottom={2}>
            <Typography variant="body2">
              <strong>Estado:</strong> {periodoSeleccionado?.estado || ""}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {periodoSeleccionado?.observacion || "Sin observacion de la institucion formadora."}
            </Typography>
          </Box>

          <Typography variant="h6" color="primary" gutterBottom>
            Gestion academica mientras se firma
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                label="Nro. renovacion"
                type="number"
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: 1, max: 3 }}
                value={gestionAcademicaForm.numeroPeriodo}
                onChange={(event) => setGestionAcademicaForm({ ...gestionAcademicaForm, numeroPeriodo: event.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Inicio gestion"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={gestionAcademicaForm.fechaInicioGestion}
                onChange={(event) => setGestionAcademicaForm({ ...gestionAcademicaForm, fechaInicioGestion: event.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Fin gestion"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={gestionAcademicaForm.fechaFinGestion}
                onChange={(event) => setGestionAcademicaForm({ ...gestionAcademicaForm, fechaFinGestion: event.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Observacion DNERHS"
                fullWidth
                multiline
                rows={3}
                value={gestionAcademicaForm.observacion}
                onChange={(event) => setGestionAcademicaForm({ ...gestionAcademicaForm, observacion: event.target.value })}
              />
            </Grid>
          </Grid>

          <Box marginTop={2} marginBottom={2} display="flex" justifyContent="flex-end">
            <Button color="primary" variant="contained" onClick={autorizarGestionAcademica}>
              Guardar gestion academica
            </Button>
          </Box>

          <Typography variant="h6" color="primary" gutterBottom>
            Renovacion firmada
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                label="Nro. renovacion"
                type="number"
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: 1, max: 3 }}
                value={aprobarRenovacionForm.numeroPeriodo}
                onChange={(event) => setAprobarRenovacionForm({ ...aprobarRenovacionForm, numeroPeriodo: event.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <TextField
                label="Numero de resolucion"
                fullWidth
                value={aprobarRenovacionForm.numeroResolucion}
                onChange={(event) => setAprobarRenovacionForm({ ...aprobarRenovacionForm, numeroResolucion: event.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Fecha firma"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={aprobarRenovacionForm.fechaFirma}
                onChange={(event) => setAprobarRenovacionForm({ ...aprobarRenovacionForm, fechaFirma: event.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Inicio vigencia"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={aprobarRenovacionForm.fechaInicioVigencia}
                onChange={(event) => setAprobarRenovacionForm({ ...aprobarRenovacionForm, fechaInicioVigencia: event.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label="Fin vigencia"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={aprobarRenovacionForm.fechaFinVigencia}
                onChange={(event) => setAprobarRenovacionForm({ ...aprobarRenovacionForm, fechaFinVigencia: event.target.value })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Observacion"
                fullWidth
                multiline
                rows={3}
                value={aprobarRenovacionForm.observacion}
                onChange={(event) => setAprobarRenovacionForm({ ...aprobarRenovacionForm, observacion: event.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenGestionarRenovacion(false)}>
            Cancelar
          </Button>
          {periodoSeleccionado?.estado === "SOLICITADA" && (
            <Button color="secondary" variant="outlined" onClick={abrirRechazoRenovacion}>
              Rechazar solicitud
            </Button>
          )}
          <Button color="primary" variant="contained" onClick={aprobarRenovacion}>
            Registrar renovacion firmada
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openRechazoRenovacion}
        onClose={() => setOpenRechazoRenovacion(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Rechazar solicitud de renovacion</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Ingrese el motivo que vera la institucion formadora.
          </Typography>
          <TextField
            label="Motivo del rechazo"
            fullWidth
            multiline
            rows={4}
            value={motivoRechazoRenovacion}
            onChange={(event) => setMotivoRechazoRenovacion(event.target.value)}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRechazoRenovacion(false)}>
            Cancelar
          </Button>
          <Button
            color="secondary"
            variant="contained"
            onClick={rechazarRenovacion}
            disabled={!motivoRechazoRenovacion.trim()}
          >
            Confirmar rechazo
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Form;
